import type { ChargerStatus } from "../types";

type Status = string | null | undefined;

export function getChargerStatusString(
  lastFirmwareStatus: Status,
  lastEvosCustomStatus: Status,
  lastOcppStatus: Status
): ChargerStatus {
  if (lastFirmwareStatus === "Downloading") return "Downloading" as ChargerStatus;
  if (lastEvosCustomStatus != null && lastEvosCustomStatus !== "ChargeDeniedInvalid" && lastEvosCustomStatus !== "ChargeDeniedMaintenance") {
    return lastEvosCustomStatus as ChargerStatus;
  }
  if (lastOcppStatus != null) return lastOcppStatus as ChargerStatus;
  return "Unknown";
}
